let vm = null
export const RunTest = function (_vm, printers, db) {
  vm = _vm
  console.log('TestPrinters.RunTest() Started ...')
  let method = 'Log'
  method = 'Refresh'
  // let counter = 0
  // let max = 3
  let promises = []
  let totalPrinters = printers.length
  let totalSuccess = 0
  let totalFailed = 0
  // max = 1
  for (let printer of printers) {
    // if (counter >= max) return
    // counter++
    console.log('Start LogPrinterPromise(' + printer.MacAddress + ')')
    printer.Logged = vm.$moment().format('YYYY-MM-DD HH:mm:ss')
    if (method === 'Log') {
      let pLog = LogPrinterPromise(printer, db).then((result) => {
        console.log('Finished LogPrinterPromise(' + printer.MacAddress + ')')
        console.log('result >>> ')
        console.log(result)
        totalSuccess++
        return Promise.resolve(result)
      }).catch(function (err) {
        console.log('Error (' + printer.MacAddress + '): ' + err.message)
        totalFailed++
        return Promise.reject(printer)
      })
      promises.push(pLog)
    } else if (method === 'Refresh') {
      let pRefresh = RefreshPrinterPromise(printer, db).then((result) => {
        console.log('Finished RefreshPrinterPromise(' + printer.MacAddress + ')')
        console.log('result >>> ')
        console.log(result)
        totalSuccess++
        return Promise.resolve(result)
      }).catch(function (err) {
        console.log('Error (' + printer.MacAddress + '): ' + err.message)
        totalFailed++
        return Promise.reject(printer)
      })
      promises.push(pRefresh)
    } else {
      console.log('Finished With Error >>> [NO_METHOD](' + printer.MacAddress + ')')
      console.log('result >>> ')
      console.log(printer)
      totalFailed++
      promises.push(Promise.reject(printer))
      // return Promise.reject(printer)
    }
  }
  console.log('BEFORE:: Promise.all(promises).then()')
  Promise.all(promises).then(() => {
    console.log('INSIDE:: Promise.all(promises).then()')
    console.log(promises)
    console.log('RefreshPrintersArr totalPrinters = ' + totalPrinters)
    console.log('RefreshPrintersArr totalSuccess = ' + totalSuccess)
    console.log('RefreshPrintersArr totalFailed = ' + totalFailed)
  })
  console.log('AFTER:: Promise.all(promises).then()')
}

function RefreshPrinterPromise (printer, db) {
  return IsValidPrinter(printer).then(() => {
    console.log('Valid Printer (' + printer.MacAddress + ')')
    return UpdatePrinter(printer, db).then((updatedPrinter) => {
      console.log('Printer UPDATED Successfuly.. ' + updatedPrinter.MacAddress)
      return RemoveRefreshPrinter(printer, db).then((removedPrinter) => {
        return PushPrinterHistory(printer, db).then((historyPrinter) => {
          return Promise.resolve(historyPrinter)
        }).catch((err) => catchError(905, 'PushPrinterHistory', err.message))
      }).catch((err) => catchError(904, 'RemoveRefreshPrinter', err.message))
    }).catch((err) => catchError(903, 'UpdatePrinter', err.message))
  }).catch((err) => catchError(901, 'IsValidPrinter', err.message))
}

function LogPrinterPromise (printer, db) {
  return IsValidPrinter(printer).then(() => {
    console.log('Valid Printer (' + printer.MacAddress + ')')
    return IsExistPrinter(printer, db).then((foundPrinter) => {
      console.log('foundPrinter = ' + foundPrinter)
      // let isExist = foundPrinter.val()
      let isExist = !(foundPrinter === null)
      let isMoved = false
      let oldSiteKey = ''
      let oldCustomerKey = ''
      let oldDealerKey = ''
      if (isExist) {
        console.log('Printer Exists! lets UPDATE it.. ' + printer.MacAddress)
        oldSiteKey = foundPrinter.SiteKey
        oldCustomerKey = foundPrinter.CustomerKey
        oldDealerKey = foundPrinter.DealerKey
        isMoved = oldSiteKey !== printer.SiteKey
      } else {
        console.log('Printer Does NOT Exist! lets INSERT it.. ' + printer.MacAddress)
      }
      return UpdatePrinter(printer, db).then((updatedPrinter) => {
        if (isExist) {
          console.log('Printer UPDATED Successfuly.. ' + updatedPrinter.MacAddress)
        } else {
          console.log('Printer INSERTED Successfuly.. ' + updatedPrinter.MacAddress)
        }
        return RemoveRefreshPrinter(printer, db).then((removedPrinter) => {
          return PushPrinterHistory(printer, db).then((historyPrinter) => {
            return IsExistInFirstDayOfMonth(printer, db).then((existPrinterFirstDayOfMonth) => {
              console.log('IsExistInFirstDayOfMonth >> ' + existPrinterFirstDayOfMonth.val())
              if (existPrinterFirstDayOfMonth.val()) {
                return UpdateDashboardCounters(printer, db, isExist, isMoved, oldSiteKey, oldCustomerKey, oldDealerKey).then((dashboardCountersPrinter) => {
                  return Promise.resolve(dashboardCountersPrinter)
                })
              } else {
                return GetPrinterLastRecordPrevMonths(printer, db).then((lastRecordPrinter) => {
                  console.log('GetPrinterLastRecordPrevMonths >> ' + lastRecordPrinter.val())
                  if (lastRecordPrinter.val()) {
                    return UpdateDashboardCounters(printer, db, isExist, isMoved, oldSiteKey, oldCustomerKey, oldDealerKey).then((dashboardCountersPrinter) => {
                      return Promise.resolve(dashboardCountersPrinter)
                    })
                  } else {
                    const firstDayFirstHour = vm.$moment(printer.LoggedInt, 'YYYYMMDDHHmm').format('YYYYMM') + '01' + '0000'
                    console.log('Insert the same Printer record in first day in this month (' + firstDayFirstHour + ')')
                    printer.LoggedInt = Number(firstDayFirstHour)
                    printer.Logged = vm.$moment(firstDayFirstHour, 'YYYYMMDDHHmm').format('YYYY-MM-DD HH:mm:ss')
                    printer = addPrinterKeys(printer)
                    delete printer['.key']
                    return PushPrinterHistory(printer, db).then((lastRecordHistoryPrinter) => {
                      return UpdateDashboardCounters(printer, db, isExist, isMoved, oldSiteKey, oldCustomerKey, oldDealerKey).then((dashboardCountersPrinter) => {
                        return Promise.resolve(dashboardCountersPrinter)
                      })
                    })
                  }
                }).catch((err) => catchError(908, 'GetPrinterLastRecordPrevMonths', err.message))
              }
            }).catch((err) => catchError(907, 'IsExistInFirstDayOfMonth ', err.message))
          }).catch((err) => catchError(905, 'PushPrinterHistory', err.message))
        }).catch((err) => catchError(904, 'RemoveRefreshPrinter', err.message))
      }).catch((err) => catchError(903, 'UpdatePrinter', err.message))
    }).catch((err) => catchError(902, 'IsExistPrinter', err.message))
  }).catch((err) => catchError(901, 'IsValidPrinter', err.message))
}

function IsValidPrinter (printer) {
  console.log('IsValidPrinter() Started. [' + printer.MacAddress + ']')
  if (printer) {
    if (printer.DealerKey && printer.DealerKey.length > 0) {
      if (printer.CustomerKey && printer.CustomerKey.length > 0) {
        if (printer.SiteKey && printer.SiteKey.length > 0) {
          console.log('Printer  [' + printer.MacAddress + '] is vaild.')
          return Promise.resolve(true)
        } else {
          return Promise.reject({ message: 'Missing [Printer.SiteKey] !!' + printer.MacAddress })
        }
      } else {
        return Promise.reject({ message: 'Missing [Printer.CustomerKey] !!' + printer.MacAddress })
      }
    } else {
      return Promise.reject({ message: 'Missing [Printer.DealerKey] !!' + printer.MacAddress })
    }
  } else {
    return Promise.reject({ message: 'Missing [Printer] !!' + printer.MacAddress })
  }
}

function IsExistPrinter (printer, db) {
  console.log('IsExistPrinter() Started.')
  console.log('MacAddress = [' + printer.MacAddress + ']')
  return db.ref('Printers/' + printer.MacAddress).once('value').then(function (snapPrinter) {
    console.log('snapPrinter.val() = ')
    console.log(snapPrinter.val())
    let isExist = snapPrinter.exists()
    if (isExist) {
      return Promise.resolve(snapPrinter.val())
    } else {
      return Promise.resolve(null)
    }
  }).catch((err) => catchError(909, 'IsExistPrinter', err.message))
}

function UpdatePrinter (printer, db) {
  console.log('UpdatePrinter() Started. [' + printer.MacAddress + ']')
  delete printer['.key']
  printer.IsRefresh = 'Ready'
  printer = addPrinterKeys(printer)
  // db.ref('Printers/' + printer.MacAddress + '/IsRefresh').set(printer.IsRefresh)
  // printer.Logged = '2019-05-21 14:99:99'
  return db.ref('Printers/' + printer.MacAddress).set(printer).then(() => {
    console.log('Printer Updated and Logged to Date : ' + printer.Logged)
    return Promise.resolve(printer)
  }).catch((err) => catchError(910, 'UpdatePrinter', err.message))
}

function RemoveRefreshPrinter (printer, db) {
  console.log('Remove printer [' + printer.MacAddress + '] from Refresh list..')
  // console.log('Remove Path = ' + 'RefreshPrinter/' + printer.SiteKey + '/' + printer.MacAddress)
  try {
    db.ref('RefreshPrinter/' + printer.SiteKey + '/' + printer.MacAddress).remove()
    console.log('Printer  [' + printer.MacAddress + '] is removed from Refresh list.')
    return Promise.resolve(printer)
  } catch (e) {
    return catchError(911, 'RemoveRefreshPrinter', e.message)
  }
}

function PushPrinterHistory (printer, db) {
  console.log('Push Printer History [printer]')
  console.log(printer)
  console.log('Push Printer History [' + printer.MacAddress + ']')
  delete printer['.key']
  return db.ref('History').push(printer).then(() => {
    console.log('Printer History Pushed : ' + printer.Logged)
    return Promise.resolve(printer)
  }).catch((err) => catchError(912, 'PushPrinterHistory', err.message))
}

function IsExistInFirstDayOfMonth (printer, db) {
  console.log('Push Printer First Day History [' + printer.MacAddress + ']')
  const firstDayFirstHour = vm.$moment(printer.LoggedInt, 'YYYYMMDDHHmm').format('YYYYMM') + '01' + '0000'
  const firstDayLastHour = vm.$moment(printer.LoggedInt, 'YYYYMMDDHHmm').format('YYYYMM') + '01' + '2359'
  console.log('firstDayFirstHour=' + firstDayFirstHour)
  console.log('firstDayLastHour=' + firstDayLastHour)
  const startAtValue = printer.DealerKey + '_' + printer.CustomerKey + '_' + printer.SiteKey + '_' + printer.MacAddress + '_' + firstDayFirstHour
  const endAtValue = printer.DealerKey + '_' + printer.CustomerKey + '_' + printer.SiteKey + '_' + printer.MacAddress + '_' + firstDayLastHour
  console.log('startAtValue=')
  console.log(startAtValue)
  console.log('endAtValue=')
  console.log(endAtValue)
  console.log('### GOT ERROR HERE ### >>>>> Error: memory limit exceeded. Function invocation was interrupted.')
  return db.ref('History').orderByChild('DateDealerCustomerSiteMacKey').startAt(startAtValue).endAt(endAtValue).limitToFirst(1).once('value', (snapPrinter) => {
    console.log('snapPrinter.val() = ' + printer['.key'])
    console.log(snapPrinter.val())
    let isExist = snapPrinter.exists()
    if (isExist) {
      console.log('Printer Exists in first day in this month!')
      return Promise.resolve(snapPrinter.val())
    } else {
      console.log('Printer Does NOT Exists in first day of this month!')
      return Promise.resolve(null)
    }
  }).catch((err) => catchError(913, 'IsExistInFirstDayOfMonth', err.message))
}

function GetPrinterLastRecordPrevMonths (printer, db) {
  const firstDayFirstHour = vm.$moment(printer.LoggedInt, 'YYYYMMDDHHmm').format('YYYYMM') + '01' + '0000'
  const firstDayLastHour = vm.$moment(printer.LoggedInt, 'YYYYMMDDHHmm').format('YYYYMM') + '01' + '2359'
  console.log('firstDayFirstHour=' + firstDayFirstHour)
  console.log('firstDayLastHour=' + firstDayLastHour)
  const lastDayLastHourPrevMonth = vm.$moment(firstDayFirstHour, 'YYYYMMDDHHmm').add(-1, 'days').format('YYYYMMDD') + '2359'
  const lastDayLastHourPrevYear = vm.$moment(lastDayLastHourPrevMonth, 'YYYYMMDDHHmm').add(-1, 'year').format('YYYYMMDD') + '0000'
  const endAtPrevMonthValue = printer.DealerKey + '_' + printer.CustomerKey + '_' + printer.SiteKey + '_' + printer.MacAddress + '_' + lastDayLastHourPrevMonth
  const startAtPrevYearValue = printer.DealerKey + '_' + printer.CustomerKey + '_' + printer.SiteKey + '_' + printer.MacAddress + '_' + lastDayLastHourPrevYear
  console.log('lastDayLastHourPrevYear=' + lastDayLastHourPrevYear)
  console.log('lastDayLastHourPrevMonth=' + lastDayLastHourPrevMonth)
  console.log(lastDayLastHourPrevYear)
  console.log(lastDayLastHourPrevMonth)
  console.log('startAtPrevYearValue=')
  console.log('endAtPrevMonthValue=')
  console.log(startAtPrevYearValue)
  console.log(endAtPrevMonthValue)
  return db.ref('History').orderByChild('DateDealerCustomerSiteMacKey').startAt(startAtPrevYearValue).endAt(endAtPrevMonthValue).limitToFirst(1).once('value', (snapPrinter) => {
    console.log('snapPrinter.val() = ' + printer['.key'])
    console.log(snapPrinter.val())
    let isExist = snapPrinter.exists()
    if (isExist) {
      console.log('Found Printer last record from prev month(s)!')
      return Promise.resolve(snapPrinter.val())
    } else {
      console.log('Not Found Printer last record from prev month(s)!')
      return Promise.resolve(null)
    }
  }).catch((err) => catchError(901, 'GetPrinterLastRecordPrevMonths', err.message))
}

function UpdateDashboardCounters (printer, db, isExist, isMoved, oldSiteKey, oldCustomerKey, oldDealerKey) {
  console.log('Update Dashborad Counters [' + printer.MacAddress + ']')
  console.log('UpdateDashboardCounters() : isExist = ' + isExist)
  console.log('UpdateDashboardCounters() : isMoved = ' + isMoved)
  return UpdateHistoryPrintersCounter(printer, db, 1).then(() => {
    if (isExist) {
      if (isMoved) {
        // Increment Site Printers by 1
        return UpdateSitePrintersCounter(printer, db, 1).then(() => {
          // Decrement Old-Site Printers by -1
          printer.DealerKey = oldDealerKey
          printer.CustomerKey = oldCustomerKey
          printer.SiteKey = oldSiteKey
          // return UpdateSitePrintersCounter(printer, db, -1)
          return UpdateSitePrintersCounter(printer, db, -1).then(() => {
            console.log('UpdateDashboardCounters() : Success.')
            return Promise.resolve(printer)
          }).catch((err) => catchError(914, 'UpdateDashboardCounters', err.message))
        })
      } else {
        return Promise.resolve(printer)
      }
    } else {
      // Increment Dealer Printers by 1
      return UpdateDealerPrintersCounter(printer, db, 1).then(() => {
        // Increment Customer Printers by 1
        return UpdateCustomerPrintersCounter(printer, db, 1).then(() => {
          // Increment Site Printers by 1
          // return UpdateSitePrintersCounter(printer, db, 1)
          return UpdateSitePrintersCounter(printer, db, 1).then(() => {
            console.log('UpdateDashboardCounters() : Success.')
            return Promise.resolve(printer)
          }).catch((err) => catchError(913, 'UpdateDashboardCounters', err.message))
        })
      })
    }
  }).catch((err) => catchError(914, 'UpdateDashboradCounters', err.message))
}

function UpdateHistoryPrintersCounter (printer, db, val) {
  console.log('Update History Printers Counter [' + printer.MacAddress + ']')
  return db.ref('History/Count').once('value').then(function (snapNewHistoryCount) {
    let historyCount = snapNewHistoryCount.val()
    return db.ref('History/Count').set(historyCount + val)
  })
}

function UpdateDealerPrintersCounter (printer, db, val) {
  console.log('Update Dealer Printers Counter [' + printer.MacAddress + ']')
  return db.ref('Dealers/' + printer.DealerKey + '/TotalPrinters').once('value').then(function (snapDealerTotalPrinters) {
    let totalDealerPrinters = snapDealerTotalPrinters.val()
    return db.ref('Dealers/' + printer.DealerKey + '/TotalPrinters').set(totalDealerPrinters + val)
  })
}

function UpdateCustomerPrintersCounter (printer, db, val) {
  console.log('Update Customer Printers Counter [' + printer.MacAddress + ']')
  return db.ref('Dealers/' + printer.DealerKey + '/Customers/' + printer.CustomerKey + '/TotalPrinters').once('value').then(function (snapCustomerTotalPrinters) {
    let totalCustomerPrinters = snapCustomerTotalPrinters.val()
    return db.ref('Dealers/' + printer.DealerKey + '/Customers/' + printer.CustomerKey + '/TotalPrinters').set(totalCustomerPrinters + val)
  })
}

function UpdateSitePrintersCounter (printer, db, val) {
  console.log('Update Site Printers Counter [' + printer.MacAddress + ']')
  return db.ref('Dealers/' + printer.DealerKey + '/Customers/' + printer.CustomerKey + '/Sites/' + printer.SiteKey + '/TotalPrinters').once('value').then(function (snapSiteTotalPrinters) {
    let totalSitePrinters = snapSiteTotalPrinters.val()
    return db.ref('Dealers/' + printer.DealerKey + '/Customers/' + printer.CustomerKey + '/Sites/' + printer.SiteKey + '/TotalPrinters').set(totalSitePrinters + val)
  })
}

function addPrinterKeys (printer) {
  console.log('Add Printer Keys [' + printer.MacAddress + ']')
  printer.DealerCustomerKey = printer.DealerKey + '_' + printer.CustomerKey
  printer.DealerCustomerSiteKey = printer.DealerKey + '_' + printer.CustomerKey + '_' + printer.SiteKey
  printer.DealerCustomerSiteMacKey = printer.DealerKey + '_' + printer.CustomerKey + '_' + printer.SiteKey + '_' + printer.MacAddress

  printer.DateMacKey = printer.MacAddress + '_' + printer.LoggedInt
  printer.DateDealerKey = printer.DealerKey + '_' + printer.LoggedInt
  printer.DateDealerCustomerKey = printer.DealerKey + '_' + printer.CustomerKey + '_' + printer.LoggedInt
  printer.DateDealerCustomerSiteKey = printer.DealerKey + '_' + printer.CustomerKey + '_' + printer.SiteKey + '_' + printer.LoggedInt
  printer.DateDealerCustomerSiteMacKey = printer.DealerKey + '_' + printer.CustomerKey + '_' + printer.SiteKey + '_' + printer.MacAddress + '_' + printer.LoggedInt
  return printer
}

function catchError (code, func, msg) {
  let errMsg = '[' + func + '] >>> ' + msg
  console.log(func + ' Error (' + code + ') : ' + errMsg)
  return Promise.reject({ Code: 200, Message: errMsg })
}



// WEBPACK FOOTER //
// ./src/plugins/TestPrinters.js